(function () {
  if (window.__catzyfiedBundleSectionsLoaded) return;
  window.__catzyfiedBundleSectionsLoaded = true;

  function readState() {
    var root = document.querySelector('[data-catzy-bundle]');
    if (!root) return null;
    return {
      group: root.dataset.bundleGroup || '',
      modelLabel: root.dataset.selectedModelLabel || 'Kabellos Classic',
      includedLabel: root.dataset.selectedIncludedLabel || 'Kabelloser Katzenbrunnen',
      variantKey: root.dataset.selectedVariantKey || ''
    };
  }

  function syncFeederImage(slot, variantKey) {
    var image = slot.querySelector('[data-bundle-feeder-image]');
    var dataEl = slot.querySelector('[data-bundle-feeder-media-json]');
    if (!image || !dataEl || !variantKey) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var variants = data.variants || [];
    var match = variants.find(function (item) {
      return item.key === variantKey;
    });

    if (!match || !match.src) return;
    if (image.getAttribute('src') !== match.src) {
      image.style.opacity = '0';
      image.setAttribute('src', match.src);
      image.removeAttribute('srcset');
      image.setAttribute('alt', match.alt || 'Smart CatzyFeeder');
      window.setTimeout(function () {
        image.style.opacity = '1';
      }, 60);
    }
  }

  function syncProducts(state) {
    document.querySelectorAll('[data-bundle-products-section]').forEach(function (section) {
      section.querySelectorAll('[data-bundle-product-feeder]').forEach(function (el) {
        el.textContent = state.variantKey || '1 oder 2 Futteraufsätze wählbar';
      });

      var group = section.dataset.bundleGroup || state.group || '';
      section.querySelectorAll('[data-bundle-product-slot]').forEach(function (slot) {
        var role = slot.dataset.bundleRole || '';
        var model = slot.dataset.bundleModel || '';
        var show = true;

        if ((group === 'feeding' || group === 'complete') && role === 'fountain') {
          show = model === state.modelLabel;
        }

        slot.hidden = !show;

        if (role === 'feeder') {
          syncFeederImage(slot, state.variantKey);
        }
      });
    });
  }

  function syncCompare(state) {
    document.querySelectorAll('[data-bundle-compare-current]').forEach(function (card) {
      card.querySelectorAll('[data-bundle-current-fountain]').forEach(function (el) {
        el.textContent = state.includedLabel || state.modelLabel || 'Katzenbrunnen';
      });
      card.querySelectorAll('[data-bundle-current-feeder]').forEach(function (el) {
        el.textContent = state.variantKey || '';
      });
    });
  }


  function syncFilterAbo(state) {
    var slugMap = {
      'Kabellos Classic': 'classic',
      'Katzenbrunnen 2.0': '2-0',
      'Edelstahl Pro': 'edelstahl-pro'
    };

    document.querySelectorAll('[data-bundle-filter-abo]').forEach(function (section) {
      var model = state.modelLabel || 'Kabellos Classic';
      if (state.group === 'edelstahl') model = 'Edelstahl Pro';

      section.querySelectorAll('[data-filter-abo-media]').forEach(function (media) {
        media.hidden = media.dataset.filterAboMedia !== model;
      });

      section.querySelectorAll('[data-filter-abo-model-label]').forEach(function (label) {
        label.textContent = model;
      });

      section.querySelectorAll('[data-filter-abo-link]').forEach(function (link) {
        var slug = slugMap[model] || 'classic';
        link.setAttribute('href', '/pages/filter-abo?model=' + encodeURIComponent(slug) + '#filter-abo-auswahl');
      });
    });
  }

  function sync(state) {
    if (!state) return;
    syncProducts(state);
    syncCompare(state);
    syncFilterAbo(state);
  }

  function init() {
    sync(readState());
  }

  document.addEventListener('catzy:bundle-change', function (event) {
    sync(event.detail || readState());
  });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
